
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    email: undefined,
    password: undefined,

    submitting: false,
    error: undefined as Error | undefined,
  }),
  methods: {
    submit() {
      this.submitting = true

      this.$store
        .dispatch('login', { email: this.email, password: this.password })
        // .then(res => console.log(res))
        .then(() => this.$router.push({ name: 'home' }))
        .catch((err) => (this.error = err))
        .finally(() => (this.submitting = false))
    },
  },
})
